export enum SlotStatus {
  AVAILABLE = 'available',
  UNAVAILABLE = 'unavailable',
}

export interface SchedulesSearchSlot {
  id: string;
  date: string;
  start: string;
  end: string;
  status: SlotStatus;
  type: string;
  scheduleId: string;
}
